var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// - Import react components
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { push } from 'react-router-redux';
import copy from 'copy-to-clipboard';
import { getTranslate } from 'react-localize-redux';
import { db } from 'data/firestoreClient';
// - Material UI
import Card from '@material-ui/core/Card';
import { withStyles } from '@material-ui/core/styles';
import './PostComp.css';
import Img3 from 'components/img3';
// - Import actions
import * as voteActions from 'store/actions/voteActions';
import * as postActions from 'store/actions/postActions';
import * as commentActions from 'store/actions/commentActions';
import * as globalActions from 'store/actions/globalActions';
import * as checkoutActions from 'store/actions/checkoutActions';
var styles = function (theme) {
    var _a;
    return ({
        iconButton: {
            marginLeft: 5
        },
        vote: {
            display: 'flex',
            flex: 1
        },
        voteCounter: {
            color: 'rgb(134, 129, 129)',
            fontSize: 10,
            fontWeight: 400,
            padding: 2,
            zIndex: 1
        },
        commentCounter: {
            color: 'rgb(134, 129, 129)',
            fontSize: 10,
            fontWeight: 400,
            padding: 4
        },
        popperOpen: {
            zIndex: 10
        },
        popperClose: {
            pointerEvents: 'none',
            zIndex: 0
        },
        postBody: {
            wordWrap: 'break-word',
            color: 'rgba(55, 0, 0, 0.01)',
            fontSize: '1.15rem',
            fontWeight: 400,
            fontFamily: '"Lato", sans-serif',
            lineHeight: '1.46429em'
        },
        image: {
            width: '100%',
            height: 900
        },
        fullPageXs: (_a = {},
            _a[theme.breakpoints.down('xs')] = {
                width: '100%',
                height: '100%',
                margin: 0,
                overflowY: 'auto'
            },
            _a)
    });
};
// - Create component class
var CPostComponent = /** @class */ (function (_super) {
    __extends(CPostComponent, _super);
    function CPostComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.styles = {
            dialog: {
                width: '',
                maxWidth: '400px',
                borderRadius: '85px',
            },
            wordStyle: {
                color: 'red'
            },
            price: {
                color: 'black',
                fontSize: '1.3rem',
                letterSpacing: '.010em',
                margin: 'auto',
                marginLeft: '1%',
                fontFamily: 'Arial, Helvetica, sans-serif',
            },
        };
        _this.slider = React.createRef();
        _this.mount = React.createRef();
        _this.post = React.createRef();
        _this.pg = React.createRef();
        _this.handleOpenComments = function () {
            var _a = _this.props, getPostComments = _a.getPostComments, commentList = _a.commentList, post = _a.post;
            var id = post.get('id');
            var ownerUserId = post.get('ownerUserId');
            if (!commentList) {
                getPostComments(ownerUserId, id);
            }
            _this.setState({
                openComments: !_this.state.openComments
            });
        };
        _this.swipeUp = function () {
            var slider = _this.slider.current;
            slider.addEventListener('touchmove', function (event) { event.preventDefault(); }, true);
            // event.preventDefault()
            _this.slider.current.style.height === '400px' ? _this.slider.current.style.height = '54px' : _this.slider.current.style.height = '400px';
        };
        /**
         * Open post write
         *
         *
         * @memberof StreamComponent
         */
        _this.handleOpenPostWrite = function () {
            _this.setState({
                openPostWrite: true
            });
        };
        /**
         * Close post write
         *
         *
         * @memberof StreamComponent
         */
        _this.handleClosePostWrite = function () {
            _this.setState({
                openPostWrite: false
            });
        };
        /**
         * Delete a post
         *
         *
         * @memberof Post
         */
        _this.handleDelete = function () {
            var post = _this.props.post;
            _this.props.delete(post.get('id'));
        };
        /**
         * Open post menu
         */
        _this.openPostMenu = function (event) {
            _this.setState({
                postMenuAnchorEl: event.currentTarget,
                isPostMenuOpen: true
            });
        };
        /**
         * Close post menu
         */
        _this.closePostMenu = function (event) {
            _this.setState({
                postMenuAnchorEl: event.currentTarget,
                isPostMenuOpen: false
            });
        };
        _this.doubletap = function () {
            if (_this.state.available === true) {
                var timeout;
                var lastTap = 0;
                var post = _this.post.current;
                var mount = _this.mount.current;
                mount.style.position = 'absolute';
                mount.style.backgroundSize = 'cover';
                mount.style.backgroundPosition = 'center';
                mount.style.backgroundImage = "url(" + require('../../assets/images/Greybag.png') + ")";
                mount.classList.toggle('puff-out-center');
                // mount.className = 'puff-out-center'
                setTimeout(function () {
                    var mount = _this.mount.current;
                    if (mount) {
                        mount.style.backgroundImage = '';
                        mount.style.position = '';
                        mount.className = '';
                    }
                }, 1500);
                _this.props.AddPostToBag();
                // alert('blue')
                var AddPostToBag_1 = _this.props.AddPostToBag;
                post.addEventListener('touchend', function (event) {
                    var currentTime = new Date().getTime();
                    var tapLength = currentTime - lastTap;
                    clearTimeout(timeout);
                    if (tapLength < 500 && tapLength > 0) {
                        // tslint:disable-next-line
                        AddPostToBag_1;
                        event.preventDefault();
                    }
                    else {
                        timeout = setTimeout(function () {
                            clearTimeout(timeout);
                        }, 500);
                    }
                    lastTap = currentTime;
                });
            }
            else {
                alert('Not Yet Available');
            }
        };
        /**
         * Show copy link
         *
         *
         * @memberof Post
         */
        _this.handleCopyLink = function () {
            var translate = _this.props.translate;
            _this.setState({
                openCopyLink: true,
                shareTitle: translate('post.copyLinkButton')
            });
        };
        /**
         * Open share post
         *
         *
         * @memberof Post
         */
        _this.handleOpenShare = function () {
            var post = _this.props.post;
            copy(location.origin + "/" + post.get('ownerUserId') + "/posts/" + post.get('id'));
            _this.setState({
                shareOpen: true
            });
        };
        /**
         * Close share post
         *
         *
         * @memberof Post
         */
        _this.handleCloseShare = function () {
            _this.setState({
                shareOpen: false,
                shareTitle: 'Share On',
                openCopyLink: false
            });
        };
        /**
         * Handle vote on a post
         *
         *
         * @memberof Post
         */
        _this.handleVote = function () {
            if (_this.props.currentUserVote) {
                _this.props.unvote();
            }
            else {
                _this.props.vote();
            }
        };
        _this.capitalize = function (str) {
            //  const {post} = this.props
            //  post.get('ownerDisplayName')
            //  var string = post.get('ownerDisplayName')
            str = str.toLowerCase()
                .split(' ')
                .map(function (s) { return s.charAt(0).toUpperCase() + s.substring(1); })
                .join(' ');
            return str;
        };
        /**
         * Set open comment group function on state which passed by CommentGroup component
         * @param  {function} open the function to open comment list
         */
        _this.getOpenCommentGroup = function (open) {
            _this.setState({
                openCommentGroup: open
            });
        };
        var post = props.post;
        _this.state = {
            /**
             * Post text
             */
            text: post.get('body', ''),
            /**
             * It's true if whole the text post is visible
             */
            readMoreState: false,
            /**
             * Handle open comment from parent component
             */
            openComments: false,
            /**
             * If it's true, share dialog will be open
             */
            shareOpen: false,
            /**
             * If it's true comment will be disabled on post
             */
            disableComments: post.get('disableComments', false),
            /**
             * If it's true share will be disabled on post
             */
            disableSharing: post.get('disableSharing', false),
            /**
             * Title of share post
             */
            shareTitle: 'Share On',
            /**
             * If it's true, post link will be visible in share post dialog
             */
            openCopyLink: false,
            /**
             * If it's true, post write will be open
             */
            openPostWrite: false,
            /**
             * Post menu anchor element
             */
            postMenuAnchorEl: null,
            /**
             * Whether post menu open
             */
            isPostMenuOpen: false,
            fabric: post.get('fabric'),
            price: post.get('price'),
            available: post.get('available') || false,
            img3Height: window.outerWidth > 500 ? '27vw' : '162px',
            ArFile: post.get('ArFile'),
        };
        // Binding functions to this
        _this.handleReadMore = _this.handleReadMore.bind(_this);
        _this.getOpenCommentGroup = _this.getOpenCommentGroup.bind(_this);
        _this.handleVote = _this.handleVote.bind(_this);
        _this.handleOpenShare = _this.handleOpenShare.bind(_this);
        _this.handleCloseShare = _this.handleCloseShare.bind(_this);
        _this.handleCopyLink = _this.handleCopyLink.bind(_this);
        _this.handleDelete = _this.handleDelete.bind(_this);
        _this.handleOpenPostWrite = _this.handleOpenPostWrite.bind(_this);
        _this.handleClosePostWrite = _this.handleClosePostWrite.bind(_this);
        _this.handleOpenComments = _this.handleOpenComments.bind(_this);
        _this.capitalize = _this.capitalize.bind(_this);
        _this.swipeUp = _this.swipeUp.bind(_this);
        return _this;
    }
    /**
     * Toggle on show/hide comment
     * @param  {event} evt passed by clicking on comment slide show
     */
    CPostComponent.prototype.componentDidMount = function () {
        var _this = this;
        var post = this.props.post;
        var pg = this.pg.current;
        var slider = this.slider.current;
        // if (pg && slider) {
        //  slider.style.width = `${pg.offsetWidth}`
        // }
        db.collection('posts').doc(post.get('id'))
            .onSnapshot(function (posts) {
            // console.log('POSS', posts.get('available'))
            _this.setState({ available: posts.get('available') }); // ALLOWS FOR INSTANT UPDATES
        });
    };
    CPostComponent.prototype.componentWillUpdate = function () {
    };
    /**
     * Handle read more event
     * @param  {event} evt  is the event passed by click on read more
     */
    CPostComponent.prototype.handleReadMore = function (event) {
        this.setState({
            readMoreState: !this.state.readMoreState
        });
    };
    CPostComponent.prototype.slide = function () {
        this.slider.current.style.height === '400px' ? this.slider.current.style.height = '54px' : this.slider.current.style.height = '400px';
    };
    /**
     * Reneder component DOM
     * @return {react element} return the DOM which rendered by component
     */
    CPostComponent.prototype.render = function () {
        var _this = this;
        var _a = this.props, post = _a.post, setHomeTitle = _a.setHomeTitle, goTo = _a.goTo, fullName = _a.fullName, isPostOwner = _a.isPostOwner, commentList = _a.commentList, classes = _a.classes, translate = _a.translate;
        var _b = this.state, postMenuAnchorEl = _b.postMenuAnchorEl, isPostMenuOpen = _b.isPostMenuOpen;
        var _c = post.toJS(), ownerUserId = _c.ownerUserId, ownerDisplayName = _c.ownerDisplayName, creationDate = _c.creationDate, image = _c.image, imageArr = _c.imageArr, body = _c.body, id = _c.id, disableComments = _c.disableComments, commentCounter = _c.commentCounter, disableSharing = _c.disableSharing;
        var postImages = (imageArr.map(function (postImage) {
            return React.createElement(Img3, { objectFit: _this.props.objectFit, key: postImage.id, ArFile: _this.state.ArFile, width: '100%', model: postImage });
        }));
        // Define variables
        return (React.createElement("div", { onDoubleClick: this.doubletap, ref: this.post, className: 'postTest' },
            React.createElement("div", { ref: this.mount }),
            React.createElement(Card, { style: { borderRadius: '6px', borderStyle: 'solid', borderWidth: '0px', borderColor: 'rgba(163, 165, 167,0.17)', maxWidth: '700px' }, elevation: .3, key: "post-component-" + id },
                imageArr ? (
                // <Img4 model={image} edit={false} color={'green'}/>
                React.createElement("div", null,
                    React.createElement(NavLink, { to: "/" + post.get('ownerUserId') + "/posts/" + post.get('id') }, postImages[0])))
                    : '',
                React.createElement("div", { style: { textAlign: 'center' } },
                    React.createElement(NavLink, { style: { color: this.props.FontColor || 'white' }, to: "/" + post.get('ownerUserId') + "/posts/" + post.get('id') },
                        React.createElement("div", { style: { color: this.props.FontColor || 'white' }, className: 'post_info_display' },
                            this.capitalize(post.get('DesignName') || 'Undefined'),
                            React.createElement("br", null)))))));
    };
    return CPostComponent;
}(Component));
export { CPostComponent };
/**
 * Map dispatch to props
 * @param  {func} dispatch is the function to dispatch action to reducers
 * @param  {object} ownProps is the props belong to component
 * @return {object}          props of component
 */
var mapDispatchToProps = function (dispatch, ownProps) {
    var post = ownProps.post;
    return {
        vote: function () { return dispatch(voteActions.dbAddVote(post.get('id'), post.get('ownerUserId'))); },
        AddPostToBag: function () { return dispatch(checkoutActions.addToBag(post)); },
        unvote: function () { return dispatch(voteActions.dbDeleteVote(post.get('id'), post.get('ownerUserId'))); },
        delete: function (id) { return dispatch(postActions.dbDeletePost(id)); },
        toggleDisableComments: function (status) {
            dispatch(postActions.dbUpdatePost(post.set('disableComments', status), function (x) { return x; }));
        },
        toggleSharingComments: function (status) {
            dispatch(postActions.dbUpdatePost(post.set('disableSharing', status), function (x) { return x; }));
        },
        goTo: function (url) { return dispatch(push(url)); },
        setHomeTitle: function (title) { return dispatch(globalActions.setHeaderTitle(title || '')); },
        getPostComments: function (ownerUserId, postId) { return dispatch(commentActions.dbFetchComments(ownerUserId, postId)); }
    };
};
/**
 * Map state to props
 * @param  {object} state is the obeject from redux store
 * @param  {object} ownProps is the props belong to component
 * @return {object}          props of component
 */
var mapStateToProps = function (state, ownProps) {
    var uid = state.getIn(['authorize', 'uid']);
    var currentUserVote = ownProps.post.getIn(['votes', uid], false);
    var voteCount = state.getIn(['post', 'userPosts', ownProps.post.get('ownerUserId'), ownProps.post.get('id'), 'score'], 0);
    var commentList = state.getIn(['comment', 'postComments', ownProps.post.get('id')]);
    var user = state.getIn(['user', 'info', ownProps.post.get('ownerUserId')]);
    // const HTVerified = state.getIn(['user', 'info', ownProps.post.get('ownerUserId'), 'HTVerified'])
    return {
        uid: uid,
        translate: getTranslate(state.get('locale')),
        commentList: commentList,
        avatar: user ? user.avatar : '',
        fullName: user ? user.fullName : '',
        voteCount: voteCount,
        currentUserVote: currentUserVote,
        isPostOwner: uid === ownProps.post.get('ownerUserId') || uid === 'JCaq5nSOFwghysclZ9vXybDm5MM2',
        HTVerified: user ? user.HTVerified : false,
    };
};
// - Connect component to redux store
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(CPostComponent));
// - Import react components



//////////////////
// WEBPACK FOOTER
// ./src/components/post/DisplayPostDesktop.tsx
// module id = 1314
// module chunks = 0 1 2 3 4 5 6 7